import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { OpenTradeAccountParameter } from "@tSurya/Services/SubmitOpenTradeService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<OpenTradeAccountParameter, any>;

export const DispatchBeginOpenTradeAccount: HandlerType = props => {
    props.dispatch({
        type: "Custom/OpenTradeAccount/BeginOpenTradeAccount",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

// export const RequestDataFromApi: HandlerType = async props => {
//     props.apiResult = await customOpenTradeAccount(props.apiParameter);
// };

export const DispatchCompleteOpenTradeAcount: HandlerType = props => {
    if (!props.apiParameter) {
        return;
    }

    props.dispatch({
        type: "Custom/OpenTradeAccount/CompletedOpenTradeAccount",
        result: props.apiParameter,
    });
};

// export const DispatchAddFileOpenTradeAccount = (props: any) => {
//     if (!props.attachments) {
//         return;
//     }
//     props.dispatch({
//         type: "Custom/OpenTradeAccount/AddNewFile",
//         result: props.attachments,
//     });
// };

// export const DispatchDeleteFileOpenTradeAccount: HandlerType = props => {
//     if (!props.apiParameter) {
//         return;
//     }
//     props.dispatch({
//         type: "Custom/OpenTradeAccount/DeleteFile",
//         result: props.apiParameter,
//     });
// };
export const chain = [
    DispatchBeginOpenTradeAccount,
    PopulateApiParameter,
    // RequestDataFromApi,
    DispatchCompleteOpenTradeAcount,
];

const loadSaveAndContinue = createHandlerChainRunner(chain, "loadSaveAndContinue");
export default loadSaveAndContinue;
